<template>
  <div class="loader-container">
    <span class="loader-98"></span>
  </div>
</template>

<script>
export default {};
</script>